<template>
  <div class="top">
    <div class="in">
      <div class="iin">
        <div class="content">
          <a
            style="display:block; height:120px; width:120px; position:absolute; left:30px; top:50px;"
          ></a>
          <div>
            <h1>IZRAČUNAJTE SVOJE PRIHRANKE</h1>
            <p>
              Uporabite aplikacijo za izračun prihrankov ter ugotovite, kje,
              kako in koliko lahko prihranite na posameznih napravah, ki jih
              vsakodnevno uporabljate. Prihranke izračunate tako, da vnesete
              v aplikacijo obstoječe velike električne naprave v vašem
              gospodinjstvu ter na njih izvedete enega ali več priporočenih
              ukrepov.
              <a
                href="http://www.uresnicujmo.si/o_aplikaciji_za_izracun_prihrankov/predstavitev"
                target="_blank"
                alt="več"
              >Več o aplikaciji &gt;</a>
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>